import {AbstractProfileFormComponent} from "../../abstract/abstract-profile/abstract-profile-form.component";
import {Component, ViewChild} from "@angular/core";
import {ProfileFormTemplateProviders} from "../../../core/templates/profile-form.template.providers";
import {BFOnFormLoadComplete} from "../../../core/interfaces/sdk-profile-hooks.interface";
import {TreeComponent, TreeNode} from "@fgpp-ui/components";
import {SelectionTreeComponent} from "../third-party/selection-tree/selection-tree.component";

export const sortFunction =  (a: TreeNode, b: TreeNode) => {
  if (+a.id > +b.id)
    return 1;
  else if (+a.id < +b.id)
    return -1;
  else
    return 0;
} ;

@Component({
  selector: 'app-generic-tree-profile',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class GenericTreeProfileComponent extends AbstractProfileFormComponent implements BFOnFormLoadComplete {

  protected selectedTree: TreeComponent;
  protected availableTree: TreeComponent;

  @ViewChild(SelectionTreeComponent) private selectionTree: SelectionTreeComponent;

  private treeFieldName: string;

  fgppFormLoadComplete(): void {
    this.treeFieldName  =  this.getData()['TREE_FIELD_NAME'];
    this.availableTree = this.formMgr.get(`${this.treeFieldName}.availableTree`).getLayoutControl<TreeComponent>();
    this.selectedTree = this.formMgr.get(`${this.treeFieldName}.selectedTree`).getLayoutControl<TreeComponent>();
    this.availableTree.collapseAll();
    this.selectedTree.collapseAll();
    this.availableTree.setSortFn(sortFunction);
    this.selectedTree.setSortFn(sortFunction);
  }

  onUndoProfile() {
    this.showSpinner();
    this.unsubscribeValueChanges();
    this.formMgr.reset();
    this.setData(this.getOriginalData());
    this.loadDefaultValues();
    this.formMgr.patchValue(this.getOriginalData());
    this.canvasEvent.setTarget(this.formService.getId()).set('state', 'setValue').emit();
    const treeData = this.getOriginalData()[this.treeFieldName];
    this.availableTree.setData(treeData['availableTree']);
    this.selectedTree.setData(treeData['selectedTree']);
    this.formLoadStart();
    this.hideSpinner();
  }
}
